import React, { useState } from "react";
import PropTypes from "prop-types";

import { useMutation, useApolloClient } from "react-apollo";

import { Title, Fieldset } from "rbx";

import VehicleInspectionMasterForm from "./VehicleInspectionMasterForm";
import {
  UPDATE_VEHICLE_INSPECTION_MASTER_MUTATION,
  DELETE_VEHICLE_INSPECTION_MASTER_MUTATION,
  ALL_VEHICLE_INSPECTIONS_MASTER_QUERY
} from "../../graphql/Vehicles/Vehicles.graphql";

import { EditFormButtonGroup } from "../inputs";
import { ourToast as toast } from "../../utils";

const INITIAL_STATE = {
  InspectionTypeRecIdRef: "",
  MileageInterval: "",
  DaysInterval: "",
  Active: ""
};

function EditVehicleInspectionMasterForm({
  VehicleInspectionMaster,
  onComplete
}) {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState({
    ...INITIAL_STATE,
    ...VehicleInspectionMaster
  });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };

  const [updateVehicleInspectionMaster] = useMutation(
    UPDATE_VEHICLE_INSPECTION_MASTER_MUTATION,
    {
      refetchQueries: ["ALL_VEHICLE_INSPECTIONS_MASTER_QUERY"]
    }
  );

  const handleSave = async e => {
    e.preventDefault();
    try {
      setLoading(true);
      if (
        parseInt(VehicleInspectionMaster.InspectionTypeRecIdRef) !==
        parseInt(inputs.InspectionTypeRecIdRef)
      ) {
        const {
          data: { VehicleInspectionsMasters }
        } = await client.query({
          query: ALL_VEHICLE_INSPECTIONS_MASTER_QUERY,
          variables: {
            where: {
              InspectionTypeRecIdRef: parseInt(inputs.InspectionTypeRecIdRef),
              VehicleRecIdRef: parseInt(inputs.VehicleRecIdRef)
            },
            first: 1
          },
          fetchPolicy: "network-only"
        });
        if (VehicleInspectionsMasters.length) {
          throw new Error(
            "Already exist one record for this Vehicle Inspection Master."
          );
        }
      }
      await updateVehicleInspectionMaster({
        variables: {
          data: {
            VehicleRecIdRef: parseInt(inputs.VehicleRecIdRef),
            InspectionTypeRecIdRef: parseInt(inputs.InspectionTypeRecIdRef),
            Active: inputs.Active || inputs.Active === "on",
            MileageInterval: parseInt(inputs.MileageInterval),
            DaysInterval: parseInt(inputs.DaysInterval)
          },
          where: {
            RecId: parseInt(VehicleInspectionMaster.RecId)
          }
        }
      });
      toast.success("Vehicle Inspection Master updated successfully.");
      onComplete();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="edit-vehicle-inspection-form">
      <Title>Edit Vehicle Inspection Master</Title>
      <form id="edit-vehicle-inspection-form" onSubmit={handleSave}>
        <Fieldset disabled={loading}>
          <VehicleInspectionMasterForm
            inputs={inputs}
            onChange={handleChange}
          />
          <hr />
          <EditFormButtonGroup
            deleteMutation={DELETE_VEHICLE_INSPECTION_MASTER_MUTATION}
            form="edit-vehicle-inspection-form"
            loading={loading}
            refetchQueries={["ALL_VEHICLE_INSPECTIONS_QUERY"]}
            variables={{ where: { RecId: VehicleInspectionMaster.RecId } }}
            onComplete={onComplete}
          />
        </Fieldset>
      </form>
    </div>
  );
}

EditVehicleInspectionMasterForm.propTypes = {
  VehicleInspectionMaster: PropTypes.object,
  onComplete: PropTypes.func
};

export default EditVehicleInspectionMasterForm;
